/* unplugin-vue-components disabled */import script from "./LogDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogDetails.vue?vue&type=script&lang=ts&setup=true"

import "./LogDetails.vue?vue&type=style&index=0&id=56e5da62&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e5da62"]])

export default __exports__